import * as React from "react";

import { DatasheetItem } from "@modules/datasheets/components/datasheet-item";
import { DatasheetItemLabel } from "@modules/datasheets/components/datasheet-item-label";
import { CheckboxFieldProps, useCheckboxFieldController } from "./checkbox-field.controller";
import { DatasheetFieldComponentHeadingPosition } from "@common/dto/datasheet/field-component/heading-position";
import { Flex } from "@common/components/Flex";
import { Checkbox } from "@common/components/checkbox";

import { FieldContainer } from "../field-container";
import { Hint } from "@common/components/hint";

import "./checkbox-field.styles.scss";

export const CheckboxField: React.FC<CheckboxFieldProps> = React.memo((props) => {
  const { datasheetElement } = props;

  const { headingPlacedHorizontally, headingReference, headingSize, headingPosition, handleCheckboxFieldValueChange } =
    useCheckboxFieldController(props);

  const labelComponent = (
    <DatasheetItemLabel
      reference={headingReference}
      inline={headingPlacedHorizontally}
      withImg={datasheetElement.original.showfieldtype}
      withText={datasheetElement.original.headdisplay}
      text={datasheetElement.original.headtext}
      img={datasheetElement.original.field.imageURL}
      textCustomization={{
        fontSize: datasheetElement.original.headfontsize,
        fontFamily: datasheetElement.original.headfont,
        color: datasheetElement.original.headcolor,
        align: datasheetElement.original.headalign,
        fontStyles: datasheetElement.original.headstyle,
      }}
    />
  );

  return (
    <DatasheetItem
      style={{
        top:
          datasheetElement.coordinates.y -
          (datasheetElement.original.headpos === DatasheetFieldComponentHeadingPosition.top ? headingSize.height : 0),
        left:
          datasheetElement.coordinates.x -
          (datasheetElement.original.headpos === DatasheetFieldComponentHeadingPosition.left ? headingSize.width : 0),
        display: headingPlacedHorizontally ? "flex" : "block",
        alignItems: headingPlacedHorizontally ? "flex-start" : undefined,
      }}
    >
      {[DatasheetFieldComponentHeadingPosition.top, DatasheetFieldComponentHeadingPosition.left].includes(
        headingPosition
      ) && labelComponent}
      <Flex alignItems="center">
        <FieldContainer 
          showBorder={datasheetElement.original.showborder}
          width={datasheetElement.original.width}
          height={datasheetElement.original.height}
        >
          <Checkbox
            classes={{
              label: "DatasheetsResultCheckboxField__checkbox__label",
            }}
            // checked={datasheetElement.original.field.value === DatasheetCheckboxFieldValue.checked}
            checked={false}
            onChange={handleCheckboxFieldValueChange}
          />
        </FieldContainer>
        {datasheetElement.original.helptext && (
          <Hint description={datasheetElement.original.helptext} />
        )}
      </Flex>
      {[DatasheetFieldComponentHeadingPosition.bottom, DatasheetFieldComponentHeadingPosition.right].includes(
        headingPosition
      ) && labelComponent}
    </DatasheetItem>
  );
});
